import { atom } from "recoil";

export const whiteListPlayersWithdrawalsAddModalStore = atom({
	key: "whiteListPlayersWithdrawalsAddModalStore",
	default: {
		show: false,
		loaded: false,
		uid: "",
		description: "",
		brand: false,
		currentOption: {
			brand: [{value: 1, label: "Selector"}, {value: 2, label: "Brillx",}, {value: 3, label: "Friends",}, {value: 4, label: "Turbo"}, {value: 5, label: "Bounty"}, {value: 6, label: "Bitzamo"}, { value: 7, label: "Blitz" }],
		},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
